module.exports = __webpack_public_path__ + "static/media/one-occupant-dark.07f9dedc.svg";